import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { TextField, Button, Container, Typography, Box } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions, auth } from '../firebase';

export function Login() {
  const { user, login, signInWithGoogle, signInWithTwitter } = useContext(AuthContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    } else {
      setLoading(false);
    }
  }, [user, navigate]);

  const onSignInWithGoogle = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.log('Google sign-in error:', error);
    }
  };

  const onSignInWithTwitter = async () => {
    signInWithTwitter();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await login(email, password);
    } catch (error) {
      console.log("Login failed:", error);
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <Typography gutterBottom>
          Log in or <Link to="/register">register here</Link>.
        </Typography>

        <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
        />

        <TextField
            margin="normal"
            required
            fullWidth
            id="password"
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
        />
        
        <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 0 }}
            disabled={loading}
        >
          Log In
        </Button>

        <Button 
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 0 }}
          disabled={loading}
          onClick={onSignInWithGoogle}>
          Sign in with Google
        </Button>
        {/* <Button onClick={onSignInWithTwitter}>Sign in with X</Button> */}

      </Box>
    </Container>
  );
}